var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"pull-quote header-two margined-element"},[_c('v-col',{attrs:{"cols":"12"}},[_c('hr'),_c('div',{staticClass:"quote-text"},[_vm._v(" “"+_vm._s(_vm.text)+"” ")]),_c('hr')])],1)}
var staticRenderFns = []

export { render, staticRenderFns }